var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptystateNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notification-illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17602",
    "data-name": "Rectangle 17602",
    width: 96,
    height: 96,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13119",
    "data-name": "Group 13119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13118",
    "data-name": "Group 13118",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7735",
    "data-name": "Path 7735",
    d: "M48,9.532A38.468,38.468,0,1,1,9.532,48,38.468,38.468,0,0,1,48,9.532",
    fill: "#f8f9fa"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13121",
    "data-name": "Group 13121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13120",
    "data-name": "Group 13120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7736",
    "data-name": "Path 7736",
    d: "M50.127,72.7A4.97,4.97,0,0,0,54.4,67.141l-9.831,1.281A4.956,4.956,0,0,0,50.127,72.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7737",
    "data-name": "Path 7737",
    d: "M50.127,72.7A4.97,4.97,0,0,0,54.4,67.141l-9.831,1.281A4.956,4.956,0,0,0,50.127,72.7Z",
    fill: "none",
    stroke: "#212529",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7738",
    "data-name": "Path 7738",
    d: "M63.488,54.553l-1.6-12.289C60.9,34.718,56.05,28.927,48.8,28.171L48.586,26.5a3.718,3.718,0,1,0-7.374.96l.218,1.672c-6.836,2.59-10.023,9.4-9.037,16.974l1.6,12.289-2.758,3.584A2.48,2.48,0,0,0,33.5,65.958l32.37-4.217a2.486,2.486,0,0,0,1.2-4.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7739",
    "data-name": "Path 7739",
    d: "M63.488,54.553l-1.6-12.289C60.9,34.718,56.05,28.927,48.8,28.171L48.586,26.5a3.718,3.718,0,1,0-7.374.96l.218,1.672c-6.836,2.59-10.023,9.4-9.037,16.974l1.6,12.289-2.758,3.584A2.48,2.48,0,0,0,33.5,65.958l32.37-4.217a2.486,2.486,0,0,0,1.2-4.43Z",
    fill: "none",
    stroke: "#212529",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7740",
    "data-name": "Path 7740",
    d: "M55.02,27.5a4,4,0,1,1-2.842,4.891A4,4,0,0,1,55.02,27.5",
    fill: "#7e0386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7741",
    "data-name": "Path 7741",
    d: "M55.02,27.5a4,4,0,1,1-2.842,4.891A4,4,0,0,1,55.02,27.5Z",
    fill: "none",
    stroke: "#2f2f2f",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystateNotification);
export default __webpack_public_path__ + "static/media/emptystate-notification.058a97a025a57c514e0b7dd7c9706b74.svg";
export { ForwardRef as ReactComponent };